export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
      interval: 2000,
      withImage: false,
      filterBy: 'OFFER',
      filterIds: '',
      message: 'purchased',
      withVerified: true,
      showAsOffer: true,
      verifiedMessage: 'verified purchase',
      customOrders: []
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return ''
  }

  containerClasses() {
    return [
      {property: 'VerticalPosition', value: 'POSITION_BOTTOM'},
      {property: 'HorizontalPosition', value: 'POSITION_RIGHT'}
    ]
  }

  classes() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Shadow', value: 'SHADOW_MD'},
      {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
    ]
  }

  styles() {
    return [
      {property:'BorderColor', styleProperty: 'border-color', value: 'linear-gradient(0deg, #000000,#000000)'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses()
      },
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes()
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles()
      }
    }
  }
}